"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleInput = void 0;
const react_1 = __importStar(require("react"));
const styled_1 = __importDefault(require("@emotion/styled"));
const util_1 = require("./util");
const LocaleInput = ({ id = (0, util_1.uuid)(), displayDictionary, localeLabelTemplate, localeInputTemplate, value = '', onChange }) => {
    const label = displayDictionary['locale.label'];
    const placeholder = displayDictionary['locale.placeholder'];
    const handleChange = (0, react_1.useCallback)((event) => {
        if (onChange) {
            event.persist();
            onChange(event, event.target.value);
        }
    }, [onChange]);
    const StyledLabel = (0, react_1.useMemo)(() => (0, styled_1.default)('label')(localeLabelTemplate), []);
    const StyledInput = (0, react_1.useMemo)(() => (0, styled_1.default)('div')(localeInputTemplate), []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        (0, util_1.shouldShowLabel)(label) && (react_1.default.createElement(StyledLabel, { htmlFor: id, "data-ref": "label-location" }, label)),
        react_1.default.createElement(StyledInput, null,
            react_1.default.createElement("input", { "data-ref": "input-location", "data-testid": "sw-location-input", type: "text", name: "location", placeholder: placeholder, id: id, value: value, onChange: handleChange }))));
};
exports.LocaleInput = LocaleInput;
//# sourceMappingURL=LocaleInput.js.map